<div *nzModalTitle></div>

<div class="tax-documentation-modal">
  @if (isLoading()) {
    <div class="loading-state">{{ 'common.loading' | translate }}</div>
  } @else if (submittedTaxDocument()) {
    <div class="step-shell readonly-shell">
      <div class="step-header">
        <h2>{{ 'profile.taxDocumentation' | translate }}</h2>
        <p class="step-subtitle">
          <a
            class="tax-form-name-link"
            [href]="submittedTaxDocumentOriginalFormUrl()"
            target="_blank"
            rel="noopener noreferrer"
          >
            {{ submittedTaxDocumentFormNameKey() | translate }}
          </a>
          {{ submittedTaxDocumentResidencySuffixKey() | translate }}
        </p>
      </div>

      <div class="readonly-card-list">
        @for (row of submittedTaxDocumentRows(); track row.id) {
          <div class="readonly-card">
            <span class="readonly-label">{{ row.label }}</span>
            <span class="readonly-value">{{ row.value }}</span>
          </div>
        }
      </div>
    </div>
  } @else if (currentStep() === 'residency') {
    <app-tax-documentation-residency-step
      [selectedResidency]="selectedResidency()"
      [expandedResidencyInfo]="expandedResidencyInfo()"
      (residencySelected)="selectResidency($event)"
      (residencyInfoToggled)="toggleResidencyInfo($event.residency, $event.event)"
    />
  } @else if (currentStep() === 'w9') {
    <app-tax-documentation-w9-step
      [form]="form"
      [usCountryControl]="usCountryControl"
      [taxIdTypeControl]="taxIdTypeControl"
      [taxIdLabel]="taxIdLabel"
      [taxIdPlaceholder]="taxIdPlaceholder"
      [taxIdMask]="taxIdMask"
      [taxIdMaskErrorKey]="taxIdMaskErrorKey"
      [federalTaxClassifications]="federalTaxClassifications"
      [llcClassifications]="llcClassifications"
    />
  } @else if (currentStep() === 'w9-certification') {
    <app-tax-documentation-w9-certification-step [form]="form" [today]="getToday()" />
  } @else if (currentStep() === 'w8ben') {
    <app-tax-documentation-w8ben-step [form]="nonUsForm" />
  } @else if (currentStep() === 'w8ben-certification') {
    <app-tax-documentation-w8ben-certification-step [form]="nonUsCertificationForm" [today]="getToday()" />
  }
</div>

<div *nzModalFooter>
  @if (submittedTaxDocument()) {
    <korviu-button color="ghost" size="large" [disabled]="isBusy()" (onclick)="closeModal()">
      {{ 'common.close' | translate }}
    </korviu-button>
  } @else if (currentStep() === 'residency') {
    <div class="modal-footer-actions">
      <korviu-button class="flex-1" color="ghost" size="large" [disabled]="isBusy()" (onclick)="closeModal()">
        {{ 'common.cancel' | translate }}
      </korviu-button>
      <korviu-button
        class="flex-1"
        color="tertiary"
        size="large"
        [disabled]="isBusy()"
        (onclick)="goToSelectedResidencyStep()"
      >
        {{ 'common.continue' | translate }}
      </korviu-button>
    </div>
  } @else if (currentStep() === 'w9') {
    <div class="modal-footer-actions">
      <korviu-button
        class="flex-1"
        color="ghost"
        size="large"
        [disabled]="isBusy()"
        (onclick)="backToW9ResidencyStep()"
      >
        {{ 'common.back' | translate }}
      </korviu-button>
      <korviu-button
        class="flex-1"
        color="tertiary"
        size="large"
        [disabled]="!w9DetailsFormIsValid || isBusy()"
        (onclick)="goToW9CertificationStep()"
      >
        {{ 'common.continue' | translate }}
      </korviu-button>
    </div>
  } @else if (currentStep() === 'w9-certification') {
    <div class="modal-footer-actions">
      <korviu-button class="flex-1" color="ghost" size="large" [disabled]="isBusy()" (onclick)="backToW9DetailsStep()">
        {{ 'common.back' | translate }}
      </korviu-button>
      <korviu-button
        class="flex-1"
        color="tertiary"
        size="large"
        [disabled]="form.invalid || isBusy()"
        [loading]="isSaving()"
        (onclick)="saveTaxDocumentation()"
      >
        {{ 'common.save' | translate }}
      </korviu-button>
    </div>
  } @else if (currentStep() === 'w8ben') {
    <div class="modal-footer-actions">
      <korviu-button
        class="flex-1"
        color="ghost"
        size="large"
        [disabled]="isBusy()"
        (onclick)="backToResidencySelection()"
      >
        {{ 'common.back' | translate }}
      </korviu-button>
      <korviu-button
        class="flex-1"
        color="tertiary"
        size="large"
        [disabled]="nonUsForm.invalid || isBusy()"
        (onclick)="continueNonUsFlow()"
      >
        {{ 'common.continue' | translate }}
      </korviu-button>
    </div>
  } @else if (currentStep() === 'w8ben-certification') {
    <div class="modal-footer-actions">
      <korviu-button
        class="flex-1"
        color="ghost"
        size="large"
        [disabled]="isBusy()"
        (onclick)="currentStep.set('w8ben')"
      >
        {{ 'common.back' | translate }}
      </korviu-button>
      <korviu-button
        class="flex-1"
        color="tertiary"
        size="large"
        [disabled]="nonUsCertificationForm.invalid || isBusy()"
        [loading]="isSaving()"
        (onclick)="saveNonUsDocumentation()"
      >
        {{ 'common.save' | translate }}
      </korviu-button>
    </div>
  }
</div>
